"use client";

import dynamic from "next/dynamic";

import type { BlockFlowTemplateProps } from "./BlockFlowTemplate";

// Lazy-load the interactive client tree (the upload form, run hook, result + the
// canvas dot-grid placeholder, signup popover) so it ships as its own async
// chunk instead of being folded into the shared block-renderer chunk every CMS
// page first-loads. `dynamic()` only defers a client tree when called from a
// Client Component — doing it in the Server renderer is a no-op, so the tree
// leaks into that shared chunk. Mirrors `BlockFlowsDemoWrapper`.
const BlockFlowTemplate = dynamic(() => import("./BlockFlowTemplate").then(mod => mod.BlockFlowTemplate));

export function BlockFlowTemplateWrapper(props: BlockFlowTemplateProps) {
  return <BlockFlowTemplate {...props} />;
}
